import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./css/Table.css";

import { Navigation, Pagination } from "swiper/modules";
// Images
import Table1 from "./Images/table-1.png";
import Table2 from "./Images/table-2.png";
import Table3 from "./Images/table-3.png";
import Table4 from "./Images/table-4.png";
import Table5 from "./Images/table-5.png";

export const TableData = () => {
  return (
    <div className="main-container tables">
      <Swiper
        navigation={true}
        pagination={{
          dynamicBullets: true,
        }}
        modules={[Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide>
          <div className="text-white">
            <img src={Table1} alt="Description of Table 1" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="text-white">
            <img src={Table2} alt="Description of Table 2" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="text-white">
            <img src={Table3} alt="Description of Table 3" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="text-white">
            <img src={Table4} alt="Description of Table 4" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="text-white">
            <img src={Table5} alt="Description of Table 5" />
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};
